import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './AppLayout';
import Home from './pages/Home';
import About from './pages/About';
import Compare from './pages/Compare';
import LegalPage from './pages/LegalPage';

/**
 * Public app (tanıtım) routes.
 * Mounted at * in the main router; /panel/* is reserved for the panel.
 */
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="compare" element={<Compare />} />
        <Route path="privacy" element={<LegalPage legalType="privacy" />} />
        <Route path="terms" element={<LegalPage legalType="terms" />} />
        <Route path="cookies" element={<LegalPage legalType="cookies" />} />
        <Route path="refund" element={<LegalPage legalType="refund" />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
